import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/b2b/b2b.png")